__turbopack_context__.v({
  "form": "sYO4Wa_form",
  "icon": "sYO4Wa_icon",
  "img": "sYO4Wa_img",
  "link": "sYO4Wa_link",
  "logInButton": "sYO4Wa_logInButton",
  "login": "sYO4Wa_login",
  "loginForm": "sYO4Wa_loginForm",
  "loginSection": "sYO4Wa_loginSection",
  "multiFactorAuthModal": "sYO4Wa_multiFactorAuthModal",
  "passwordInput": "sYO4Wa_passwordInput",
  "passwordProvider": "sYO4Wa_passwordProvider",
  "spinnerIcon": "sYO4Wa_spinnerIcon",
  "svg__jxvgR": "sYO4Wa_svg__jxvgR",
  "svg__xiAoZ": "sYO4Wa_svg__xiAoZ",
  "text": "sYO4Wa_text",
  "text__e26Lb": "sYO4Wa_text__e26Lb",
  "title": "sYO4Wa_title",
  "usernameInput": "sYO4Wa_usernameInput",
  "usernameProvider": "sYO4Wa_usernameProvider",
  "warning": "sYO4Wa_warning",
  "wrapper": "sYO4Wa_wrapper",
  "wrapper2": "sYO4Wa_wrapper2",
  "wrapper3": "sYO4Wa_wrapper3",
  "wrapper4": "sYO4Wa_wrapper4",
});
